import { Fragment } from "react";
import { useSessionStorage } from "react-use";
import useSharedData from "../../../hooks/useSharedData";
import SenderAddress from "../../../pages/shop/components/SenderAddress";
import Footer from "../../public/footer/footer";
import Menu from "../../public/menu/menu";
import AgentCollect from "../newLetter/components/order/AgentCollect";
import CompanySection from "./components/CompanySection";
import ShipmentSectionBulk from "./components/ShipmentSectionBulk";

function Bulk() {
  const { isAgent } = useSharedData();

  const [company, setCompany] = useSessionStorage("companyBulk", {
    selected: {},
    value: -1,
  });
  const [senderAddress, setSenderAddress] = useSessionStorage("SAddress", {});

  return (
    <Fragment>
      <Menu />
      <main className="flex-grow-1 px-sm-2 px-md-3 px-xl-5 rtl-all mt-5">
        {isAgent && <AgentCollect />}
        <h1 className="mb-3">ثبت سفارش انبوه</h1>

        <SenderAddress state={{ senderAddress, setSenderAddress }} />
        <CompanySection state={{ company, setCompany }} />

        <ShipmentSectionBulk company={company} senderAddress={senderAddress} />
      </main>
      <Footer />
    </Fragment>
  );
}
export default Bulk;
